import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { advancedSearchTermAdapter } from "./advancedSearchTermAdapter";

// this should work both for the form and the results to strip any invalid term params from the URL
// TODO we may want to extend the basic search loader as well
export function advancedSearchNullTermLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const params = new URLSearchParams(url.searchParams);
  const term = params.get("term");
  const validTerm = advancedSearchTermAdapter.getTerm(params);

  if (term && !validTerm) {
    params.delete("term");
    return redirect(`/advanced-search/boolean?${params.toString()}`);
  }
  return null;
}
